<div class="container-fluid">
  <app-version-update-notification></app-version-update-notification>

  <app-header></app-header>

  @if (isAuthenticated()) {
    <app-navigation></app-navigation>
  }

  <main class="container">
    <!-- Router Outlet for Content -->
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>

  <!-- App-wide "Leave with unsaved changes?" modal (used by unsavedChangesCanDeactivateGuard) -->
  <app-confirmation-modal
    [isVisible]="leaveWithUnsavedChanges.isVisible()"
    [modalData]="leaveWithUnsavedChanges.modalData()"
    (confirm)="leaveWithUnsavedChanges.onConfirm()"
    (cancel)="leaveWithUnsavedChanges.onCancel()">
  </app-confirmation-modal>
</div>
